import * as React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import './css/index.css';
import MyApp from './App';
import About from './components/about';
import Bugs from './Bugs';
import Sidebar from './components/sidebar';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { createRoot } from 'react-dom/client';
import '@sweetalert2/themes/dark';
import { UserContext } from './components/user_Context';
import { defaultUser } from './components/userDefault';

const myDoc = document.getElementById('root');
const root = createRoot(myDoc!); // createRoot(container!) if you use TypeScript
root.render(<App />);

function App() {
  const [user, setUser] = React.useState(defaultUser);

  const CallbackGitHub = () => {
    const navigate = useNavigate();

    React.useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');

      if (code) {
        // Send code to backend
        fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/github/callback?code=` + code, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        })
          .then(response => response.json())
          .then(data => {
            if (data.success === false) {
              console.log("Error fetching GitHub authentication token.")
            } else {
              var gituser = {
                "given_name": data.data.name,
                "family_name": data.data.family_name,
                "handle": data.data.login,
                "email": data.data.notification_email,
                "picture": data.data.avatar_url,
                "id": data.data.id,
                "token": data.code,
                "provider": "GitHub"
              };
              setUser(gituser);
            }
          });
        navigate('/');
      } else {

      }
    }, []);

    return <></>;
  };

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GG_APP_ID}>

      <Router>
        <UserContext.Provider value={{ user, setUser }}>
          <Sidebar />
          <Routes>
            <Route path="/" element={<MyApp table="commenter" />} />
            <Route path="/About" element={<About />} />
            <Route path="/Bugs" element={<Bugs table="bugs" />} />
            <Route path="/auth/github/callback" Component={() => CallbackGitHub()} />
          </Routes>
        </UserContext.Provider>
      </Router>

    </GoogleOAuthProvider>
  )
};

export default App;